//Limitless imports
import { handleSecureAjaxError } from "../utils/SecurePlatformAPIUtils";
import { getGraphQLClient } from "../clients/GraphQLClient";
import { getFlagMessageQuery } from "./queries/MessageFlagMutations";
export const FLAG_TYPE_REPORT = "report";
export const FLAG_TYPE_ESCALATION = "escalation";
export const FLAG_TYPE_CONVERSATION_COMPLETE = "conversation-complete";
export const flagMessage = (message, flagPayload, callback) => {
  const graphQLClient = getGraphQLClient();
  graphQLClient.mutate({
    mutation: getFlagMessageQuery(flagPayload),
    variables: {
      messageId: message.messageId,
      ...flagPayload
    }
  }).then(response => {
    const message = response.data.flagMessage;
    callback(message);
  }).catch(error => {
    handleSecureAjaxError(error, "MessageFlagActions flagMessage");
    callback({
      hasError: true,
      error
    });
  });
};